
import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import { installChunkReloadRecovery } from "./utils/chunkReload";
import "./styles/index.css";

installChunkReloadRecovery();

createRoot(document.getElementById("root")!).render(<App />);
